import { render, staticRenderFns } from "./AccessNote.vue?vue&type=template&id=5cf74010&"
import script from "./AccessNote.vue?vue&type=script&lang=js&"
export * from "./AccessNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports